// Team
export const FETCH_TEAM_REQUEST = 'FETCH_TEAM_REQUEST'
export const FETCH_TEAM_SUCCESS = 'FETCH_TEAM_SUCCESS'
export const FETCH_TEAM_ERROR = 'FETCH_TEAM_ERROR'
export const SET_TEAM = 'SET_TEAM'

// Teams
export const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST'
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS'
export const FETCH_TEAMS_ERROR = 'FETCH_TEAMS_ERROR'
export const SET_TEAMS = 'SET_TEAMS'

// Team Modal
export const SET_TEAM_MODAL_ID = 'SET_TEAM_MODAL_ID'
export const SET_TEAM_MODAL_IS_VISIBLE = 'SET_TEAM_MODAL_IS_VISIBLE'

// Team Form
export const TEAM_FORM_REQUEST = 'TEAM_FORM_REQUEST'
export const TEAM_FORM_SUCCESS = 'TEAM_FORM_SUCCESS'
export const TEAM_FORM_ERROR = 'TEAM_FORM_ERROR'
export const SET_NAME = 'SET_NAME'
export const SET_VISIBILITY = 'SET_VISIBILITY'
export const VISIBILITY_IS_PRIVATE = 'is_private'
export const VISIBILITY_IS_PUBLIC = 'is_public'

// team destroy
export const DESTROY_TEAMS_REQUEST = 'DESTROY_TEAMS_REQUEST'
export const DESTROY_TEAMS_SUCCESS = 'DESTROY_TEAMS_SUCCESS'
export const DESTROY_TEAMS_ERROR = 'DESTROY_TEAMS_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/teams/types.js